import React from 'react';
import { Button, Grid } from '../../common';
import StandardModal from '../../common/modals/StandardModal';
import { OnPremPortOpeningRequestsTypes } from '../../../models/enums/POR/OnPremPortOpeningRequestsTypes';

export interface TrashcanModalProps {
	type: OnPremPortOpeningRequestsTypes;
	onRemove: () => any;
    onClose: () => any;
	onDelete: () => any;
}

const TrashcanModal = (trashcanModalProps: TrashcanModalProps) => {
    return (
            <StandardModal
				show={true}
				onDismiss={trashcanModalProps.onClose}
				title="Remove Rule?"
				footer={
					<Grid variant="2up">
						<Grid.Item>
							<Button variant="primary" onClick={trashcanModalProps.onDelete}>
								{`DELETE FROM ${trashcanModalProps.type.name == OnPremPortOpeningRequestsTypes.InternalCertConnection.name ? 'TRACKER' : 'DBM'} ID`}
							</Button>
						</Grid.Item>
						<Grid.Item>
							<Button variant="secondary" optionalClass="em-c-btn--accent" onClick={trashcanModalProps.onRemove}>
								REMOVE FROM REQUEST
							</Button>
						</Grid.Item>
					</Grid>
				}
			>
						You can: 
						<ul style={{listStyleType: 'disc', marginLeft: 30}}>
							<li><b>DELETE</b> {`the rule from the ${trashcanModalProps.type.name == OnPremPortOpeningRequestsTypes.InternalCertConnection.name ? 'Tracker' : 'DBM'} Id`}</li>
							<li><b>REMOVE</b> the rule from the grid</li>
						</ul> 
			</StandardModal>
    );
}

export default TrashcanModal;